module.exports = __webpack_public_path__ + "img/ghana.4f42428a.svg";